/* eslint-disable react-hooks/exhaustive-deps */
import { Container, Row, Col, Card, Collapse, Button, Table } from "react-bootstrap"
import AlertComponent from "../../../components/AlertComponent"
import * as WjRNav from "@grapecity/wijmo.react.nav"
import * as WjCNav from "@grapecity/wijmo.nav"
import CONSTANT from "../../../constant"
import { useEffect, useRef, useState } from "react"
import TextInput from "../../../components/InputWrapper/TextInput"
import ComboBox from "../../../components/ComboBox"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import DateInput from "../../../components/InputWrapper/DateInput"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import { T区分マスタ } from "../../../components/ComboBox/KubunComboBox"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "../../../globalStore/rootreducer"
import { AppDispatch } from "../../.."
import {
  getSyaryo,
  syaryoMasterActions,
  TSyaryoMasterState,
} from "../../../globalStore/pageStore/syaryoMaster/syaryoMasterStore"
import MainDataPane from "./AccordionPanes/MainDataPane"
import SyasaiDataPane from "./AccordionPanes/SyasaiDataPane"
import PictureDataPane from "./AccordionPanes/PictureDataPane"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronDown, faChevronUp, faSearch } from "@fortawesome/free-solid-svg-icons"
import "../SyaryoMasterList/App.scss"
import SyaryoRirekiRirekiData from "./AccordionPanes/SyaryoIdoRirekiPane"
import TenkenSeibiRirekiData from "./AccordionPanes/TenkenSeibiRirekiData"
import NumberInput from "../../../components/InputWrapper/NumberInput"
import RequiredMark from "../../../components/RequiredMark"
import { Prompt, useHistory, useParams } from "react-router-dom"
import BusyoService from "../../../service/master/busyo/busyoService"
import KubunService from "../../../service/master/kubun/kubunService"
import { 画面ロック解除, 画面ロック開始 } from "../../../globalStore/progressStore"
import SyaryoService from "../../../service/truck/syaryoService"
import { setAlerts } from "../../../globalStore/alertStore"
import { TSyaryoMasterPostReq, TSyaryoMasterPutReq, TSyaryoMasterTrailerPutReq } from "../../../service/truck/TSyaryo"
import Ajv from "ajv"
import ajvErrors from "ajv-errors"
import ConfirmModal from "../../../components/Modal/ConfirmModal"

import { TApiResponse } from "../../../service/TApiResponse"
import { showInfoToast } from "../../../components/CustomToast"
import SyaryoSearchModal from "../../../components/SearchModal/SyaryoSearchModal"
import ZyomuinSearchModal from "../../../components/SearchModal/ZyomuinSearchModal"

import dayjs from "dayjs"
import { jpFormat } from "dayjs-jp-format"
import ZyomuinService from "../../../service/driver/zyomuinService"
import CheckInput from "../../../components/InputWrapper/CheckInput"
import { メニューコード } from "../../../constant/menuCode"
import { SyaryoMasterRegisterProvider, TBlobContextItem } from "./SyaryoMasterRegisterContext"
import ContentService from "../../../service/content/contentService"
import { Exception } from "@zxing/library"
import { FunctionContext } from "../../../components/Context"
import TireSizeDataPane from "./AccordionPanes/TireSizeDataPane"

dayjs.extend(jpFormat)

/**
 * 車輌マスタ登録
 * @returns
 */
const SyaryoMasterRegister = () => {
  const history = useHistory()
  const { id } = useParams<{ id: string }>()
  //#region selector
  const syaryoMaster: TSyaryoMasterState = useSelector((state: RootState) => state.page.syaryoMaster)

  const 読取専用フラグ = useSelector(
    (rootState: RootState) =>
      rootState.menu.menuPage.find((m) => m.メニューコード === メニューコード.車輌管理.車輌マスタ)?.読み取り専用フラグ
  )

  const disPatch: AppDispatch = useDispatch()

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  //#endregion
  //#region [state]

  const [, set部所] = useState<T部所マスタ | null>(null)

  const [, set原動機有無フラグ] = useState<{
    name: string
    value: number
  } | null>(null)

  const [, set車種] = useState<T区分マスタ | null>(null)
  const [, set稼働手当車種掛率区分] = useState<T区分マスタ | null>(null)

  // 車体形状の初期設定用
  const [is車体形状更新, setIs車体形状更新] = useState<boolean>(false)

  // 和暦用State
  const [登録年月日_和暦, set登録年月日_和暦] = useState<string>()
  const [初年度登録年月日_和暦, set初年度登録年月日_和暦] = useState<string>()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  const [isTrailerConfirmModalShow, setIsTrailerConfirmModalShow] = useState(false)
  const [is車輌検索Modal, setIs車輌検索Modal] = useState(false)
  // 乗務員検索
  const [is乗務員検索Modal, setIs乗務員検索Modal] = useState(false)
  const [乗務員検索対象, set乗務員検索対象] = useState<"同乗者" | "乗務員">("乗務員")

  // Panel部分のcomponent生成監視フラグ
  const [車検証isLoadEnded, set車検証LoadEnded] = useState<boolean>(false)
  const [車載isLoadEnded, set車載LoadEnded] = useState<boolean>(false)
  const [isLoadEnded, setIsLoadEnded] = useState<boolean>(false)
  const [isDispatch車輌Ended, setIsDispatch車輌Ended] = useState<boolean>(false)
  const [isPictureLoaded, setIsPictureLoaded] = useState<boolean>(false)
  // 全部終わったフラグ
  const [comboDataInitialized, setComboDataInitialized] = useState(false)
  //#endregion

  //#region [comboboxState]
  // 部所ComboBox
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<string, T部所マスタ> | null>(null)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()
  const [部所isLoadEnded, set部所isLoadEnded] = useState<boolean>(false)

  // 原動機有無フラグCombobox
  const [原動機有無フラグComboBox, set原動機有無フラグComboBox] = useState<TWijmoComboBox<
    number,
    { name: string; value: number }
  > | null>(null)
  const [原動機有無フラグItemSource] = useState<{ name: string; value: number }[]>([
    { name: "あり", value: 1 },
    { name: "なし", value: 0 },
  ])
  const [原動機有無フラグisLoadEnded, set原動機有無フラグisLoadEnded] = useState<boolean>(false)
  // 車種Combobox
  const [車種ComboBox, set車種ComboBox] = useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()
  const [車種isLoadEnded, set車種isLoadEnded] = useState<boolean>(false)
  // 掛率
  const [稼働掛率isLoadEnded, set稼働掛率isLoadEnded] = useState<boolean>(false)
  const [稼働掛率ComboBox, set稼働掛率ComboBox] = useState<TWijmoComboBox<string, T区分マスタ> | null>(null)

  // BlobContext用
  const refBlobList = useRef<TBlobContextItem[]>()
  const [blobList, setBlobList] = useState<TBlobContextItem[]>([])

  //#endregion

  // #region [method]

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    //TODO: ここにバリデーションチェックを実装
    const ajv = new Ajv({ allErrors: true })
    ajvErrors(ajv)
    setIsConfirmModalShow(true)
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmitTrailer = () => {
    //TODO: ここにバリデーションチェックを実装
    const ajv = new Ajv({ allErrors: true })
    ajvErrors(ajv)
    setIsTrailerConfirmModalShow(true)
  }

  /**
   * 更新アイテム生成（トレーラ車輛）
   */
  const getTrailerPutReq = (): TSyaryoMasterTrailerPutReq => {
    return {
      トレーラ車輌ID: syaryoMaster.トレーラ車輌ID,
      更新日時: syaryoMaster.更新日時 ?? "",
    }
  }

  /**
   * 更新アイテム生成
   */
  const getPutReq = (): TSyaryoMasterPutReq => {
    console.log(syaryoMaster.車輌車載リスト)
    return {
      // 基本データ
      車番: syaryoMaster.車番 ?? "",
      部所コード: syaryoMaster.部所コード ?? "",
      担当乗務員: syaryoMaster.社員コード ?? "",
      廃車予定: syaryoMaster.廃車予定 ?? "",
      登録番号_地域名: syaryoMaster.登録番号地域 ?? "",
      登録番号_分類番号: syaryoMaster.登録番号分類 ?? "",
      登録番号_平仮名等: syaryoMaster.登録番号記号 ?? "",
      登録番号_一連指定番号: syaryoMaster.登録番号指定番号 ?? "",
      登録年月日: syaryoMaster.登録年月日 ?? "",
      初年度登録年月: syaryoMaster.初年度登録年月 ?? "",
      廃車年月: syaryoMaster.廃車年月 ?? "",
      廃車保管フラグ: syaryoMaster.廃車保管フラグ ?? 0,
      原動機有無フラグ: syaryoMaster.原動機有無フラグ ? 1 : 0,
      タイヤサイズフロント: syaryoMaster.タイヤサイズフロント ?? "",
      タイヤサイズ軸: syaryoMaster.タイヤサイズ軸 ?? "",
      予備車フラグ: syaryoMaster.予備車フラグ ?? 0,
      借用車フラグ: syaryoMaster.借用車フラグ ?? 0,
      車種コード: syaryoMaster.車種区分コード ?? "",
      稼働手当車種掛率区分コード: syaryoMaster.稼働手当車種掛率区分コード ?? "",
      トレーラ車輌ID: syaryoMaster.トレーラ車輌ID,
      変更前車番: syaryoMaster.変更前車番 ?? "",
      変更前登録番号_地域名: syaryoMaster.変更前登録番号地域 ?? "",
      変更前登録番号_分類番号: syaryoMaster.変更前登録番号分類 ?? "",
      変更前登録番号_平仮名等: syaryoMaster.変更前登録番号記号 ?? "",
      変更前登録番号_一連指定番号: syaryoMaster.変更前登録番号指定番号 ?? "",
      車番変更備考: syaryoMaster.車番変更備考 ?? "",
      // 車検証
      陸運支局報告分類区分コード: syaryoMaster.陸運支局報告分類区分コード ?? "",
      車体形状: syaryoMaster.車体形状 ?? "",
      車種詳細: syaryoMaster.車種詳細 ?? "",
      メーカーコード: syaryoMaster.メーカーコード ?? "",
      メーカー車名: syaryoMaster.メーカー車名 ?? "",
      最大積載量: syaryoMaster.最大積載量 ?? 0,
      最大積載量2: syaryoMaster.最大積載量2 ?? "",
      車輌重量: syaryoMaster.車輌重量 ?? "",
      車輌総重量: syaryoMaster.車輌総重量 ?? "",
      車台番号: syaryoMaster.車台番号 ?? "",
      長さ: syaryoMaster.長さ ?? 0,
      幅: syaryoMaster.幅 ?? 0,
      高さ: syaryoMaster.高さ ?? 0,
      シリアルNo: syaryoMaster.シリアルNo ?? "",
      前前軸重: syaryoMaster.前前軸重 ?? 0,
      前後軸重: syaryoMaster.前後軸重 ?? 0,
      後前軸重: syaryoMaster.後前軸重 ?? 0,
      後後軸重: syaryoMaster.後後軸重 ?? 0,
      車輌形式: syaryoMaster.車輌形式 ?? "",
      原動機型式: syaryoMaster.原動機型式 ?? "",
      所有者名称: syaryoMaster.所有者名称 ?? "",
      車検満了日: syaryoMaster.車検満了日 ?? "",
      使用者情報: syaryoMaster.使用者名称 ?? "",
      車輌営業所区分コード: syaryoMaster.車輌営業所 ?? "",
      // 基準緩和
      基準緩和車輌: syaryoMaster.基準緩和車輌 ?? "",
      基準緩和有効期限: syaryoMaster.基準緩和有効期限 ?? "",
      緩和書類制作会社: syaryoMaster.緩和書類制作会社 ?? "",
      緩和輸送依頼荷主: syaryoMaster.緩和輸送依頼荷主 ?? "",
      // 架装情報
      架装メーカー: syaryoMaster.架装メーカー ?? "",
      架装タンクNO: syaryoMaster.架装タンクNO ?? "",
      台帳保管ファイル名: syaryoMaster.台帳保管ファイル名 ?? "",
      架装情報備考1: syaryoMaster.備考１ ?? "",
      架装情報備考2: syaryoMaster.備考２ ?? "",
      任意保険加入フラグ: syaryoMaster.任意保険加入フラグ ? 1 : 0,
      火炎暴露保険フラグ: syaryoMaster.火炎暴露保険フラグ ? 1 : 0,
      保険NO: syaryoMaster.保険NO ?? "",
      車輌分類リスト: syaryoMaster.車輌分類,
      車輌特種リスト: syaryoMaster.車輌特種,

      // 新規アップロード以外はblobをサーバーに送信しない
      添付ファイルリスト: syaryoMaster.添付ファイルリスト.map((item) => {
        return {
          ...item,
          アップロードファイル: blobList.find((b) => b.id === item.row_id)?.blob,
        }
      }),

      // 車載データ
      標準交換距離オイル: syaryoMaster.標準交換距離オイル ?? "",
      標準交換距離エレメント: syaryoMaster.標準交換距離エレメント ?? "",
      ETC設置区分コード: syaryoMaster.ETC設置区分 ?? "",
      ETC車載器メーカー: syaryoMaster.ETC車載器メーカー ?? "",
      ETC車載器シリアルNO: syaryoMaster.ETC車載器シリアルNO ?? "",
      車輌車載リスト: syaryoMaster.車輌車載リスト,
      車輌ETCカードリスト: syaryoMaster.ETCカードリスト,
      車輌給油カードリスト: syaryoMaster.給油カードリスト,

      // 新規アップロード以外はblobをサーバーに送信しない
      車輌写真リスト: syaryoMaster.車輌写真リスト.map((item) => {
        return {
          ...item,
          アップロードファイル: item.車輌写真ID == null ? blobList.find((b) => b.id === item.row_id)?.blob : undefined,
        }
      }),

      更新日時: syaryoMaster.更新日時 ?? "",
      削除フラグ: syaryoMaster.削除フラグ ? 1 : 0,
    }
  }

  /**
   * 登録アイテム生成
   */
  const getPostReq = (): TSyaryoMasterPostReq => {
    return {
      // 基本データ
      車番: syaryoMaster.車番 ?? "",
      部所コード: syaryoMaster.部所コード ?? "",
      担当乗務員: syaryoMaster.社員コード ?? "",
      廃車予定: syaryoMaster.廃車予定 ?? "",
      登録番号_地域名: syaryoMaster.登録番号地域 ?? "",
      登録番号_分類番号: syaryoMaster.登録番号分類 ?? "",
      登録番号_平仮名等: syaryoMaster.登録番号記号 ?? "",
      登録番号_一連指定番号: syaryoMaster.登録番号指定番号 ?? "",
      登録年月日: syaryoMaster.登録年月日 ?? "",
      初年度登録年月: syaryoMaster.初年度登録年月 ?? "",
      廃車年月: syaryoMaster.廃車年月 ?? "",
      廃車保管フラグ: syaryoMaster.廃車保管フラグ ?? 0,
      原動機有無フラグ: syaryoMaster.原動機有無フラグ ? 1 : 0,
      タイヤサイズフロント: syaryoMaster.タイヤサイズフロント ?? "",
      タイヤサイズ軸: syaryoMaster.タイヤサイズ軸 ?? "",
      予備車フラグ: syaryoMaster.予備車フラグ ?? 0,
      借用車フラグ: syaryoMaster.借用車フラグ ?? 0,
      車種コード: syaryoMaster.車種区分コード ?? "",
      稼働手当車種掛率区分コード: syaryoMaster.稼働手当車種掛率区分コード ?? "",
      トレーラ車輌ID: syaryoMaster.トレーラ車輌ID,
      変更前車番: syaryoMaster.変更前車番 ?? "",
      変更前登録番号_地域名: syaryoMaster.変更前登録番号地域 ?? "",
      変更前登録番号_分類番号: syaryoMaster.変更前登録番号分類 ?? "",
      変更前登録番号_平仮名等: syaryoMaster.変更前登録番号記号 ?? "",
      変更前登録番号_一連指定番号: syaryoMaster.変更前登録番号指定番号 ?? "",
      車番変更備考: syaryoMaster.車番変更備考 ?? "",
      // 車検証
      陸運支局報告分類区分コード: syaryoMaster.陸運支局報告分類区分コード ?? "",
      車体形状: syaryoMaster.車体形状 ?? "",
      車種詳細: syaryoMaster.車種詳細 ?? "",
      メーカーコード: syaryoMaster.メーカーコード ?? "",
      メーカー車名: syaryoMaster.メーカー車名 ?? "",
      最大積載量: syaryoMaster.最大積載量 ?? 0,
      最大積載量2: syaryoMaster.最大積載量2 ?? "",
      車輌重量: syaryoMaster.車輌重量 ?? "",
      車輌総重量: syaryoMaster.車輌総重量 ?? "",
      車台番号: syaryoMaster.車台番号 ?? "",
      長さ: syaryoMaster.長さ ?? 0,
      幅: syaryoMaster.幅 ?? 0,
      高さ: syaryoMaster.高さ ?? 0,
      シリアルNo: syaryoMaster.シリアルNo ?? "",
      前前軸重: syaryoMaster.前前軸重 ?? 0,
      前後軸重: syaryoMaster.前後軸重 ?? 0,
      後前軸重: syaryoMaster.後前軸重 ?? 0,
      後後軸重: syaryoMaster.後後軸重 ?? 0,
      車輌形式: syaryoMaster.車輌形式 ?? "",
      原動機型式: syaryoMaster.原動機型式 ?? "",
      所有者名称: syaryoMaster.所有者名称 ?? "",
      車検満了日: syaryoMaster.車検満了日 ?? "",
      使用者情報: syaryoMaster.使用者名称 ?? "",
      車輌営業所区分コード: syaryoMaster.車輌営業所 ?? "",
      // 基準緩和
      基準緩和車輌: syaryoMaster.基準緩和車輌 ?? "",
      基準緩和有効期限: syaryoMaster.基準緩和有効期限 ?? "",
      緩和書類制作会社: syaryoMaster.緩和書類制作会社 ?? "",
      緩和輸送依頼荷主: syaryoMaster.緩和輸送依頼荷主 ?? "",
      // 架装情報
      架装メーカー: syaryoMaster.架装メーカー ?? "",
      架装タンクNO: syaryoMaster.架装タンクNO ?? "",
      台帳保管ファイル名: syaryoMaster.台帳保管ファイル名 ?? "",
      架装情報備考1: syaryoMaster.備考１ ?? "",
      架装情報備考2: syaryoMaster.備考２ ?? "",
      任意保険加入フラグ: syaryoMaster.任意保険加入フラグ ? 1 : 0,
      火炎暴露保険フラグ: syaryoMaster.火炎暴露保険フラグ ? 1 : 0,
      保険NO: syaryoMaster.保険NO ?? "",
      車輌分類リスト: syaryoMaster.車輌分類,
      車輌特種リスト: syaryoMaster.車輌特種,

      // 新規アップロード以外はblobをサーバーに送信しない
      添付ファイルリスト: syaryoMaster.添付ファイルリスト.map((item) => {
        return {
          ...item,
          アップロードファイル: blobList.find((b) => b.id === item.row_id)?.blob,
        }
      }),
      // 車載データ
      標準交換距離オイル: syaryoMaster.標準交換距離オイル ?? "",
      標準交換距離エレメント: syaryoMaster.標準交換距離エレメント ?? "",

      ETC設置区分コード: syaryoMaster.ETC設置区分 ?? "",
      ETC車載器メーカー: syaryoMaster.ETC車載器メーカー ?? "",
      ETC車載器シリアルNO: syaryoMaster.ETC車載器シリアルNO ?? "",
      車輌車載リスト: syaryoMaster.車輌車載リスト,
      車輌ETCカードリスト: syaryoMaster.ETCカードリスト,
      車輌給油カードリスト: syaryoMaster.給油カードリスト,

      // 新規アップロード以外はblobをサーバーに送信しない
      車輌写真リスト: syaryoMaster.車輌写真リスト.map((item) => {
        return {
          ...item,
          アップロードファイル: item.車輌写真ID == null ? blobList.find((b) => b.id === item.row_id)?.blob : undefined,
        }
      }),
    }
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      const service = new SyaryoService()

      let res: TApiResponse<boolean>
      if (id) {
        res = await service.put(id, getPutReq())
      } else {
        res = await service.post(getPostReq())
      }
      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`車輌マスタの${id ? "更新" : "登録"}が完了しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  /**
   * 送信(トレーラ車輛のみ)
   */
  const submitTrailer = async () => {
    try {
      const service = new SyaryoService()

      let res: TApiResponse<boolean>
      if (id) {
        res = await service.putTrailer(id, getTrailerPutReq())
      } else {
        // 更新時しか発火ボタン使えないが、一応IDがない場合Errorとする。
        throw new Exception(`更新対象の車輌マスタデータがありません。`)
      }
      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`車輌マスタの${id ? "更新" : "登録"}が完了しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsTrailerConfirmModalShow(false)
    }
  }

  //#endregion

  //#region [effect]
  useEffect(() => {
    document.title = `車輌マスタ登録 - ${CONSTANT.APP_NAME}`
    // 初期表示生成のため画面ロック
    disPatch(画面ロック開始())

    Promise.all([new BusyoService().getList({}), new KubunService().getList()]).then(([部所ListRes, 区分マスタRes]) => {
      set部所ItemSource(部所ListRes.data)
      set区分ItemSource(区分マスタRes.data)
      disPatch(syaryoMasterActions.init())
    })
    setComboDataInitialized(true)

    // デストラクタ
    return () => {
      disPatch(syaryoMasterActions.init())
      if (refBlobList.current != null) {
        refBlobList.current
          .filter((b) => (b.imageUrl ?? "") !== "")
          .forEach((b) => {
            try {
              URL.revokeObjectURL(b.imageUrl!)
            } catch (err) {
              // 握りつぶす
            }
          })
      }
    }
  }, [])

  useEffect(() => {
    refBlobList.current = blobList
  }, [blobList])

  //useEffect内ではasyncが使用できないため外部に記述
  const 乗務員取得 = async (社員コード?: string) => {
    if (社員コード == null || 社員コード === "") {
      disPatch(syaryoMasterActions.set社員氏名(""))
      return
    }
    try {
      const 社員res = await new ZyomuinService().getList({
        部所コード: syaryoMaster.部所コード ?? "",
        退職フラグ: 0,
        社員コード,
      })

      if (社員res != null && 社員res.data.length > 0) {
        const 社員 = 社員res.data[0]
        // serviceが前方一致でデータ取得しているので、社員コードの一致後に氏名をとる
        if (社員.社員コード === 社員コード && 社員.部所コード === syaryoMaster.部所コード && 社員.退職フラグ === 0) {
          disPatch(syaryoMasterActions.set社員氏名(社員.社員氏名))
        }
      } else {
        disPatch(syaryoMasterActions.set社員氏名(""))
      }
    } catch (error) {
      disPatch(setAlerts(error))
      disPatch(syaryoMasterActions.set社員氏名(""))
    }
  }

  // component初期化監視
  useEffect(() => {
    if (
      comboDataInitialized &&
      部所ComboBox &&
      原動機有無フラグComboBox &&
      車種ComboBox &&
      // 配下panel部分
      車検証isLoadEnded &&
      車載isLoadEnded &&
      稼働掛率ComboBox
    ) {
      setIsLoadEnded(true)
    }
  }, [
    comboDataInitialized,
    部所ComboBox,
    原動機有無フラグComboBox,
    車種ComboBox,
    車検証isLoadEnded,
    車載isLoadEnded,
    稼働掛率ComboBox,
  ])

  // componentロード後にデータ読込及び復元
  useEffect(() => {
    // component読込確認
    if (isLoadEnded) {
      if (id) {
        disPatch(getSyaryo(id))
          .catch((res) => {
            disPatch(setAlerts(res))
          })
          .finally(() => {
            setIsDispatch車輌Ended(true)
          })
      } else {
        // 初回登録時の車体形状設定の為フラグを切り替え
        setIs車体形状更新(true)
        setIsDispatch車輌Ended(true)
      }
    }
  }, [isLoadEnded])

  // 画像の読み込み
  useEffect(() => {
    if (!isDispatch車輌Ended) return
    if (isPictureLoaded) return

    const service = new ContentService()
    const taskList = syaryoMaster.車輌写真リスト.map((item) => service.get(item.ファイルURL))
    // 全ての画像を読み込み
    Promise.allSettled(taskList)
      .then((results) => {
        const newList = syaryoMaster.車輌写真リスト
          .filter((item, index) => results[index].status === "fulfilled")
          .map((item, index) => {
            const result = results[index] as PromiseFulfilledResult<Blob>
            const url = URL.createObjectURL(result.value)
            return {
              id: item.row_id!,
              blob: result.value,
              imageUrl: url,
            }
          }) as TBlobContextItem[]
        setBlobList([...blobList, ...newList])
      })
      .finally(() => {
        disPatch(画面ロック解除())
        isPrompt.current = true
        setIsPictureLoaded(true)
      })
  }, [isPictureLoaded, isDispatch車輌Ended])

  // 原動機有無フラグを監視して、トレーラ情報のclear
  useEffect(() => {
    if (syaryoMaster.原動機有無フラグ === 1) return
    disPatch(syaryoMasterActions.setトレーラ車番(undefined))
    disPatch(syaryoMasterActions.setトレーラ車輌ID(undefined))
    disPatch(syaryoMasterActions.setトレーラ車種(""))
  }, [syaryoMaster.原動機有無フラグ])

  // 廃車保管フラグclear監視
  useEffect(() => {
    if (syaryoMaster.廃車年月 == null) {
      // 廃車年月が存在しない場合、廃車保管フラグはclearされる。
      disPatch(syaryoMasterActions.set廃車保管フラグ(0))
      return
    }
  }, [syaryoMaster.廃車年月])

  // 新規登録時の初回のみ
  // 車種名称を車体形状に設定する為
  // 各要素を監視
  useEffect(() => {
    // 更新時は処理なし
    if (id) return
    if (!is車体形状更新 || !区分ItemSource || !syaryoMaster.車種区分コード) return
    disPatch(
      syaryoMasterActions.set車体形状(
        区分ItemSource
          ?.filter((i) => i.分類コード === "C0001")
          .find((i) => i.区分コード === syaryoMaster.車種区分コード)?.名称1
      )
    )
    setIs車体形状更新(false)
  }, [is車体形状更新, 区分ItemSource, syaryoMaster.車種区分コード])

  //#endregion

  return (
    <>
      <SyaryoMasterRegisterProvider
        blobList={blobList}
        addBlobItem={(newItem) => {
          setBlobList([...blobList, newItem])
        }}
        removeBlobItem={(targetId) => {
          const target = blobList.find((b) => b.id === targetId)
          if (target != null && (target.imageUrl ?? "") !== "") {
            try {
              URL.revokeObjectURL(target.imageUrl!)
            } catch (err) {
              // 握りつぶす
            }
          }
          setBlobList(blobList.filter((item) => item.id !== targetId))
        }}>
        <Prompt when={isPrompt.current} message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>
        <Container fluid>
          {/* 画面タイトル */}
          <Row className="page-title-row">
            <Col className="page-title-col">
              <span className="page-title">車輌マスタ{id ? `更新` : `登録`}</span>
            </Col>
          </Row>
          {/* アラート表示 */}
          <Row>
            <Col>
              <AlertComponent />
            </Col>
          </Row>
          <Row>
            <Col>
              {/* 常時表示データ */}
              <Card className="w-130rem">
                <Card.Header
                  onClick={() => setAccordionController(!accordionController)}
                  aria-controls="collapse-cardbody"
                  aria-expanded={accordionController}>
                  <FontAwesomeIcon icon={accordionController ? faChevronDown : faChevronUp} size={"1x"} />
                  基本データ
                </Card.Header>
                <Collapse in={accordionController}>
                  <Card.Body>
                    <Container className="register-form" fluid>
                      <Row>
                        <Col>
                          <Table className="form-table">
                            <tbody>
                              <tr>
                                <th className="min-w-8rem">
                                  車輌
                                  <RequiredMark />
                                </th>
                                <td>
                                  <div className="input-group">
                                    <TextInput
                                      style={{ width: "5rem" }}
                                      id="車番"
                                      name="車番"
                                      maxLength={4}
                                      placeholder="車番"
                                      value={syaryoMaster.車番}
                                      setValue={(v) => disPatch(syaryoMasterActions.set車番(v))}
                                      autoFocus={true}
                                    />
                                    <NumberInput
                                      style={{ width: "5rem" }}
                                      id="車輌id"
                                      name="車輌id"
                                      placeholder="ID"
                                      readOnly={true}
                                      value={parseInt(id)}
                                      setValue={(v) => {}}
                                    />
                                  </div>
                                </td>
                                <th className="min-w-8rem">
                                  部所
                                  <RequiredMark />
                                </th>
                                <td>
                                  <div className="input-group">
                                    <ComboBox.Busyo
                                      isLoadEnded={部所isLoadEnded}
                                      setIsLoadEnded={set部所isLoadEnded}
                                      isReadOnly={id ? true : false}
                                      isAllSelect={false}
                                      isRequired={true}
                                      itemsSource={部所ItemSource}
                                      selectedValue={syaryoMaster.部所コード}
                                      setSelectedValue={(v) => {
                                        disPatch(syaryoMasterActions.set部所コード(v))
                                      }}
                                      setSelectedItem={set部所}
                                      ComboBox={部所ComboBox}
                                      setComboBox={set部所ComboBox}></ComboBox.Busyo>
                                  </div>
                                </td>
                                <th className="min-w-8rem">担当乗務員</th>
                                <td>
                                  <div className="input-group">
                                    <TextInput
                                      style={{ width: "6rem" }}
                                      id="担当乗務員"
                                      name="担当乗務員"
                                      maxLength={4}
                                      value={syaryoMaster.社員コード}
                                      onBlur={async (e) => {
                                        // TODO: 単票系のAutoComplete未実装
                                        const v = e.currentTarget.value
                                        乗務員取得(v)
                                      }}
                                      setValue={(v) => {
                                        disPatch(syaryoMasterActions.set社員コード(v))
                                      }}
                                    />
                                    <button type="button" className="icon-button">
                                      <a
                                        href="*"
                                        onClick={(e) => {
                                          e.preventDefault()
                                          set乗務員検索対象("乗務員")
                                          setIs乗務員検索Modal(true)
                                        }}>
                                        <FontAwesomeIcon
                                          className="icon-button-inner"
                                          icon={faSearch}></FontAwesomeIcon>
                                      </a>
                                    </button>
                                    <TextInput
                                      style={{ width: "10rem" }}
                                      id="担当乗務員名"
                                      name="担当乗務員名"
                                      isReadOnly={true}
                                      value={syaryoMaster.社員氏名}
                                      setValue={(v) => disPatch(syaryoMasterActions.set社員氏名(v))}
                                    />
                                  </div>
                                </td>
                                <th className="min-w-8rem">廃車予定年月</th>
                                <td>
                                  <div className="input-group w-8rem">
                                    <MonthInput
                                      id="廃車予定"
                                      value={syaryoMaster.廃車予定}
                                      setValue={(v) => disPatch(syaryoMasterActions.set廃車予定(v))}></MonthInput>
                                  </div>
                                </td>
                                <th className="input-w-8rem">予備車フラグ</th>
                                <td>
                                  <div className="input-group w-8rem">
                                    <CheckInput
                                      id="予備車フラグ"
                                      type={"switch"}
                                      label={""}
                                      setValue={(v) => disPatch(syaryoMasterActions.set予備車フラグ(v))}
                                      value={syaryoMaster.予備車フラグ ?? 0}
                                    />
                                  </div>
                                </td>
                              </tr>

                              <tr>
                                <th className="min-w-8rem">
                                  原動機有無
                                  <RequiredMark />
                                </th>
                                <td>
                                  <div className="input-group w-10rem">
                                    <ComboBox.Default
                                      isLoadEnded={原動機有無フラグisLoadEnded}
                                      setIsLoadEnded={set原動機有無フラグisLoadEnded}
                                      isAllSelect={false}
                                      isRequired={true}
                                      itemsSource={原動機有無フラグItemSource}
                                      selectedValue={syaryoMaster.原動機有無フラグ}
                                      setSelectedValue={(v) => disPatch(syaryoMasterActions.set原動機有無フラグ(v))}
                                      setSelectedItem={set原動機有無フラグ}
                                      ComboBox={原動機有無フラグComboBox}
                                      setComboBox={set原動機有無フラグComboBox}></ComboBox.Default>
                                  </div>
                                </td>
                                <th className="input-w-8rem">
                                  登録年月日
                                  <RequiredMark />
                                </th>
                                <td>
                                  <div className="input-group w-17rem d-flex">
                                    <div className="d-flex">
                                      <DateInput
                                        id="登録年月日"
                                        value={syaryoMaster.登録年月日}
                                        setValue={(v) => {
                                          disPatch(syaryoMasterActions.set登録年月日(v))
                                          // 和暦変換
                                          if (v == null) return
                                          set登録年月日_和暦(dayjs(v).format("rrrr"))
                                        }}></DateInput>
                                      <TextInput
                                        style={{ width: "7rem" }}
                                        id="登録年月日_和暦"
                                        name="登録年月日_和暦"
                                        maxLength={5}
                                        isReadOnly
                                        value={登録年月日_和暦}
                                        setValue={(v) => {}}></TextInput>
                                    </div>
                                  </div>
                                </td>
                                <th className="input-w-8rem">初年度登録年月</th>
                                <td>
                                  <div className="input-group w-15rem">
                                    <div className="d-flex">
                                      <MonthInput
                                        id="初年度登録年月"
                                        value={syaryoMaster.初年度登録年月}
                                        setValue={(v) => {
                                          disPatch(syaryoMasterActions.set初年度登録年月(v))
                                          // 和暦変換
                                          if (v == null) return
                                          set初年度登録年月日_和暦(dayjs(v).format("rrrr"))
                                        }}></MonthInput>
                                      <TextInput
                                        style={{ width: "7rem" }}
                                        id="初年度登録年月日_和暦"
                                        name="初年度登録年月日_和暦"
                                        maxLength={5}
                                        isReadOnly
                                        value={初年度登録年月日_和暦}
                                        setValue={(v) => {}}></TextInput>
                                    </div>
                                  </div>
                                </td>
                                <th className="input-w-8rem">廃車年月</th>
                                <td>
                                  <div className="input-group w-8rem">
                                    <MonthInput
                                      id="廃車年月"
                                      value={syaryoMaster.廃車年月}
                                      setValue={(v) => disPatch(syaryoMasterActions.set廃車年月(v))}></MonthInput>
                                  </div>
                                </td>
                                <th className="input-w-8rem">廃車保管フラグ</th>
                                <td>
                                  <div className="input-group w-8rem">
                                    <CheckInput
                                      id="廃車保管フラグ"
                                      type={"switch"}
                                      label={""}
                                      isDisabled={syaryoMaster.廃車年月 ? false : true}
                                      setValue={(v) => disPatch(syaryoMasterActions.set廃車保管フラグ(v))}
                                      value={syaryoMaster.廃車保管フラグ ?? 0}
                                    />
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </Table>

                          <Table className="form-table">
                            <tbody>
                              {/* 車種/登録番号/トレーラ車輛 */}
                              <tr>
                                <th className="min-w-8rem">
                                  車種
                                  <RequiredMark />
                                </th>
                                <td>
                                  <div className="input-group">
                                    <ComboBox.Kubun
                                      isLoadEnded={車種isLoadEnded}
                                      setIsLoadEnded={set車種isLoadEnded}
                                      isAllSelect={false}
                                      isRequired={true}
                                      itemsSource={区分ItemSource}
                                      分類コード="C0001"
                                      selectedValue={syaryoMaster.車種区分コード}
                                      setSelectedValue={(v) => disPatch(syaryoMasterActions.set車種コード(v))}
                                      setSelectedItem={set車種}
                                      ComboBox={車種ComboBox}
                                      setComboBox={set車種ComboBox}></ComboBox.Kubun>
                                  </div>
                                </td>
                                <th className="input-w-8rem">
                                  登録番号
                                  <RequiredMark />
                                </th>
                                <td>
                                  <div className="input-group">
                                    <TextInput
                                      style={{ width: "7rem" }}
                                      id="地域名"
                                      name="地域名"
                                      placeholder="地域"
                                      maxLength={5}
                                      value={syaryoMaster.登録番号地域}
                                      setValue={(v) => disPatch(syaryoMasterActions.set登録番号_地域名(v))}
                                    />
                                    <TextInput
                                      style={{ width: "5rem" }}
                                      id="分類番号"
                                      name="分類番号"
                                      placeholder="分類"
                                      maxLength={3}
                                      value={syaryoMaster.登録番号分類}
                                      setValue={(v) => disPatch(syaryoMasterActions.set登録番号_分類番号(v))}
                                    />
                                    <TextInput
                                      style={{ width: "4rem" }}
                                      id="平仮名等"
                                      name="平仮名等"
                                      placeholder="記号"
                                      maxLength={1}
                                      value={syaryoMaster.登録番号記号}
                                      setValue={(v) => disPatch(syaryoMasterActions.set登録番号_平仮名等(v))}
                                    />
                                    <TextInput
                                      style={{ width: "6rem" }}
                                      id="一連指定番号"
                                      name="一連指定番号"
                                      placeholder="番号"
                                      maxLength={4}
                                      value={syaryoMaster.登録番号指定番号}
                                      setValue={(v) => disPatch(syaryoMasterActions.set登録番号_一連指定番号(v))}
                                    />
                                  </div>
                                </td>
                                <th className="min-w-8rem">トレーラ車輌</th>
                                <td>
                                  <div className="input-group">
                                    <TextInput
                                      style={{ width: "5rem" }}
                                      id="トレーラ車番"
                                      name="トレーラ車番"
                                      isReadOnly={
                                        true
                                        // TODO:単票系のAutoComplete実装されたら手入力可能にする。
                                        // 削除ボタンも同時にやめる
                                        // syaryoMaster.原動機有無フラグ !== 1
                                      }
                                      maxLength={4}
                                      value={syaryoMaster.トレーラ車番}
                                      setValue={(v) => disPatch(syaryoMasterActions.setトレーラ車番(v))}
                                    />
                                    {syaryoMaster.原動機有無フラグ === 1 && (
                                      <button
                                        type="button"
                                        className="icon-button"
                                        onClick={(e) => {
                                          if (syaryoMaster.原動機有無フラグ !== 1) return
                                          e.preventDefault()
                                          setIs車輌検索Modal(true)
                                        }}>
                                        <FontAwesomeIcon
                                          className="icon-button-inner"
                                          icon={faSearch}></FontAwesomeIcon>
                                      </button>
                                    )}
                                    <TextInput
                                      style={{ width: "10rem" }}
                                      id="トレーラ車種"
                                      name="トレーラ車種"
                                      isReadOnly={true}
                                      value={syaryoMaster.トレーラ車種区分名称1}
                                      setValue={(v) => disPatch(syaryoMasterActions.setトレーラ車種(v))}
                                    />
                                    <Button
                                      type="submit"
                                      className="ms-1"
                                      onClick={() => {
                                        disPatch(syaryoMasterActions.setトレーラ車番(undefined))
                                        disPatch(syaryoMasterActions.setトレーラ車輌ID(undefined))
                                        disPatch(syaryoMasterActions.setトレーラ車種(""))
                                      }}>
                                      クリア
                                    </Button>
                                    {id != null && 読取専用フラグ === 1 && (
                                      <Button
                                        type="submit"
                                        variant="waiting"
                                        className="ms-2"
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          e.preventDefault()
                                          beforeSubmitTrailer()
                                        }}>
                                        更新
                                      </Button>
                                    )}
                                  </div>
                                </td>
                                <th className="min-w-8rem">稼働掛率</th>
                                <td>
                                  <div className="input-group w-7rem">
                                    <ComboBox.Kubun
                                      isLoadEnded={稼働掛率isLoadEnded}
                                      setIsLoadEnded={set稼働掛率isLoadEnded}
                                      isAllSelect={false}
                                      isRequired={false}
                                      itemsSource={区分ItemSource}
                                      分類コード="T0004"
                                      selectedValue={syaryoMaster.稼働手当車種掛率区分コード}
                                      setSelectedValue={(v) =>
                                        disPatch(syaryoMasterActions.set稼働手当車種掛率区分コード(v))
                                      }
                                      setSelectedItem={set稼働手当車種掛率区分}
                                      ComboBox={稼働掛率ComboBox}
                                      setComboBox={set稼働掛率ComboBox}></ComboBox.Kubun>
                                  </div>
                                </td>
                              </tr>

                              {/* 変更前車番/登録前変更番号/備考 */}
                              <tr>
                                <th className="min-w-8rem">変更前車番</th>
                                <td>
                                  <div className="input-group">
                                    <TextInput
                                      style={{ width: "5rem" }}
                                      id="変更前車番"
                                      name="変更前車番"
                                      maxLength={4}
                                      value={syaryoMaster.変更前車番}
                                      setValue={(v) => disPatch(syaryoMasterActions.set変更前車番(v))}
                                    />
                                  </div>
                                </td>
                                <th className="min-w-8rem">変更前登録番号</th>
                                <td>
                                  <div className="input-group">
                                    <TextInput
                                      style={{ width: "7rem" }}
                                      id="地域名"
                                      name="地域名"
                                      placeholder="地域"
                                      maxLength={4}
                                      value={syaryoMaster.変更前登録番号地域}
                                      setValue={(v) => disPatch(syaryoMasterActions.set変更前登録番号_地域名(v))}
                                    />
                                    <TextInput
                                      style={{ width: "5rem" }}
                                      id="分類番号"
                                      name="分類番号"
                                      placeholder="分類"
                                      maxLength={3}
                                      value={syaryoMaster.変更前登録番号分類}
                                      setValue={(v) => disPatch(syaryoMasterActions.set変更前登録番号_分類番号(v))}
                                    />
                                    <TextInput
                                      style={{ width: "4rem" }}
                                      id="平仮名等"
                                      name="平仮名等"
                                      placeholder="記号"
                                      maxLength={1}
                                      value={syaryoMaster.変更前登録番号記号}
                                      setValue={(v) => disPatch(syaryoMasterActions.set変更前登録番号_平仮名等(v))}
                                    />
                                    <TextInput
                                      style={{ width: "6rem" }}
                                      id="一連指定番号"
                                      name="一連指定番号"
                                      placeholder="番号"
                                      maxLength={4}
                                      value={syaryoMaster.変更前登録番号指定番号}
                                      setValue={(v) => disPatch(syaryoMasterActions.set変更前登録番号_一連指定番号(v))}
                                    />
                                  </div>
                                </td>
                                <th className="min-w-8rem">備考</th>
                                <td>
                                  <div className="input-group">
                                    <TextInput
                                      style={{ width: "30rem" }}
                                      id="備考"
                                      name="備考"
                                      value={syaryoMaster.車番変更備考}
                                      setValue={(v) => disPatch(syaryoMasterActions.set備考(v))}
                                    />
                                  </div>
                                </td>
                                <th className="input-w-8rem">借用車フラグ</th>
                                <td>
                                  <div className="input-group w-8rem">
                                    <CheckInput
                                      id="借用車フラグ"
                                      type={"switch"}
                                      label={""}
                                      setValue={(v) => disPatch(syaryoMasterActions.set借用車フラグ(v))}
                                      value={syaryoMaster.借用車フラグ ?? 0}
                                    />
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </Col>
                      </Row>
                    </Container>
                    <Row>
                      <Col>
                        {!読取専用フラグ && (
                          <Button
                            type="submit"
                            variant="waiting"
                            onClick={(e) => {
                              e.stopPropagation()
                              e.preventDefault()
                              beforeSubmit()
                            }}>
                            {id ? `更新` : `登録`}
                          </Button>
                        )}
                        <Button type="button" variant="secondary" className="ms-4" onClick={() => history.goBack()}>
                          一覧に戻る
                        </Button>
                      </Col>
                    </Row>
                  </Card.Body>
                </Collapse>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card className="w-130rem">
                <Card.Body>
                  <WjRNav.Accordion
                    initialized={(e: WjCNav.Accordion) => {
                      e.selectedIndex = 1
                    }}
                    isAnimated={false}
                    allowExpandMany={true}
                    allowCollapseAll={true}>
                    <WjRNav.AccordionPane>
                      {/* タイヤサイズ */}
                      <TireSizeDataPane />
                    </WjRNav.AccordionPane>
                    <WjRNav.AccordionPane>
                      {/* 車検証 */}
                      <MainDataPane isLoadEnded={車検証isLoadEnded} setIsLoadEnded={set車検証LoadEnded}></MainDataPane>
                    </WjRNav.AccordionPane>
                    <WjRNav.AccordionPane>
                      {/* 車載データ */}
                      <SyasaiDataPane isLoadEnded={車載isLoadEnded} setIsLoadEnded={set車載LoadEnded}></SyasaiDataPane>
                    </WjRNav.AccordionPane>
                    <WjRNav.AccordionPane>
                      {/* 写真データ */}
                      <PictureDataPane></PictureDataPane>
                    </WjRNav.AccordionPane>
                    <WjRNav.AccordionPane>
                      {/* 点検整備履歴データ */}
                      <TenkenSeibiRirekiData></TenkenSeibiRirekiData>
                    </WjRNav.AccordionPane>
                    <WjRNav.AccordionPane>
                      <FunctionContext.Provider
                        value={() => {
                          disPatch(getSyaryo(id))
                            .catch((res) => {
                              disPatch(setAlerts(res))
                            })
                            .finally(() => {
                              setIsDispatch車輌Ended(true)
                            })
                        }}>
                        {/* 車輌異動履歴 */}
                        <SyaryoRirekiRirekiData></SyaryoRirekiRirekiData>
                      </FunctionContext.Provider>
                    </WjRNav.AccordionPane>
                  </WjRNav.Accordion>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          {/* 登録確認 */}
          <ConfirmModal isShow={isConfirmModalShow} hideHandler={setIsConfirmModalShow} submitHandler={submit}>
            入力された内容で{id ? "更新" : "登録"}しますか？
          </ConfirmModal>
          {/* 登録確認（トレーラ車輛） */}
          <ConfirmModal
            isShow={isTrailerConfirmModalShow}
            hideHandler={setIsTrailerConfirmModalShow}
            submitHandler={submitTrailer}>
            入力された内容でトレーラ車輛を更新しますか？
          </ConfirmModal>
          {/* 車輌検索 */}
          <SyaryoSearchModal
            setIsShow={(v) => {
              setIs車輌検索Modal(v)
            }}
            isShow={is車輌検索Modal}
            原動機有無フラグ={0}
            busyoCode={syaryoMaster.部所コード ?? ""}
            setSyaryo={(車輌) => {
              disPatch(syaryoMasterActions.setトレーラ車輌ID(車輌.車輌ID))
              disPatch(syaryoMasterActions.setトレーラ車番(車輌.車番))
              disPatch(syaryoMasterActions.setトレーラ車種(車輌.車種区分名称1))
            }}></SyaryoSearchModal>
          {/* 乗務員検索 */}
          <ZyomuinSearchModal
            isShow={is乗務員検索Modal}
            setIsShow={setIs乗務員検索Modal}
            busyoCode={syaryoMaster.部所コード ?? ""}
            setZyomuin={(乗務員) => {
              switch (乗務員検索対象) {
                case "乗務員":
                  disPatch(syaryoMasterActions.set社員コード(乗務員.社員コード))
                  disPatch(syaryoMasterActions.set社員氏名(乗務員.社員氏名))
                  break
                case "同乗者":
                  break
                default:
                  break
              }
            }}></ZyomuinSearchModal>
        </Container>
      </SyaryoMasterRegisterProvider>
    </>
  )
}

export default SyaryoMasterRegister
